import React, { Component } from 'react'
import { connect } from 'react-redux'
import { _DOTNET, _JAVA, _PHP } from '../../../actions/types'

class _3RINonRecurringSample extends Component {
    getOrderId() {
        const { order_id, selectedProgLangId } = this.props;
        if(order_id === "none") {
            switch(selectedProgLangId) {
                case _DOTNET:
                    return `"Test" + DateTime.Now.ToString("yyyyMMddhhmmss")`;
                case _JAVA:
                    return `"Test"+createDate.getTime()`;
                case _PHP:
                    return `'ord-'.date("dmy-G:i:s")`;
                default:
                    return "";
            }
        }
        else
            return `"${order_id}"`;
    }

    getValue(val, id) {
        return (
            <span className= {this.props.onEditId === id ? 'codeValue' : ''}>{val}</span>
        );
    }

    render() {
        const { storeId, apiToken, pan, selectedProgLangId } = this.props;

        switch(selectedProgLangId) {
            case _DOTNET:
                return (
                    <pre className="sampleCode">
{`using System;
using Moneris;
using System.Collections;


public class TestCanadaMpiThreeDSAuthentication
{
	public static void Main(string[] args)
	{
		string store_id = "moneris";
		string api_token = "hurgle";
		
		string processing_country_code = "CA";

		MpiThreeDSAuthentication mpiThreeDSAuthentication = new MpiThreeDSAuthentication();
        mpiThreeDSAuthentication.SetOrderId("Test1597873519352");	//must be the same one that was used in MpiCardLookup call
        mpiThreeDSAuthentication.SetCardholderName("Moneris Test");
        mpiThreeDSAuthentication.SetPan("347668693641199");
		//mpiThreeDSAuthentication.SetDataKey("8OOXGiwxgvfbZngigVFeld9d2"); //Optional - For Moneris Vault and Hosted Tokenization tokens in place of SetPan
        mpiThreeDSAuthentication.SetExpdate("2310");
        mpiThreeDSAuthentication.SetAmount("1.00");
        mpiThreeDSAuthentication.SetThreeDSCompletionInd("Y"); //(Y|N|U) indicates whether 3ds method MpiCardLookup was successfully completed
        mpiThreeDSAuthentication.SetRequestType("01"); //(01=payment|02=recur)
        mpiThreeDSAuthentication.SetPurchaseDate("20200819035249"); //(YYYYMMDDHHMMSS)
        mpiThreeDSAuthentication.SetNotificationURL("https://yournotificationurl.com"); //(Website where response from RRes or CRes after challenge will go)
        mpiThreeDSAuthentication.SetChallengeWindowSize("03"); //(01 = 250 x 400, 02 = 390 x 400, 03 = 500 x 600, 04 = 600 x 400, 05 = Full screen)
        
        mpiThreeDSAuthentication.SetBrowserUserAgent("Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/80.0.3987.132 Safari/537.36\\");
        mpiThreeDSAuthentication.SetBrowserJavaEnabled("true"); //(true|false)
        mpiThreeDSAuthentication.SetBrowserScreenHeight("1000"); //(pixel height of cardholder screen)
        mpiThreeDSAuthentication.SetBrowserScreenWidth("1920"); //(pixel width of cardholder screen)
        mpiThreeDSAuthentication.SetBrowserLanguage("en-GB"); //(defined by IETF BCP47)
        
        //Optional Methods
		mpiThreeDSAuthentication.SetBillAddress1("3300 Bloor St W");
        mpiThreeDSAuthentication.SetBillProvince("ON");
        mpiThreeDSAuthentication.SetBillCity("Toronto");
        mpiThreeDSAuthentication.SetBillPostalCode("M8X 2X2");
        mpiThreeDSAuthentication.SetBillCountry("124");
        
        mpiThreeDSAuthentication.SetShipAddress1("3300 Bloor St W");
        mpiThreeDSAuthentication.SetShipProvince("ON");
        mpiThreeDSAuthentication.SetShipCity("Toronto");
        mpiThreeDSAuthentication.SetShipPostalCode("M8X 2X2");
        mpiThreeDSAuthentication.SetShipCountry("124");

        mpiThreeDSAuthentication.SetEmail("test@email.com");
        mpiThreeDSAuthentication.SetRequestChallenge("Y"); //(Y|N Requesting challenge regardless of outcome)
        //**********************3DS2.2*****************************************
        mpiThreeDSAuthentication.SetMessageCategory("01");
        mpiThreeDSAuthentication.SetDeviceChannel("02");
//       mpiThreeDSAuthentication.SetDecoupledRequestIndicator("Y");
//      mpiThreeDSAuthentication.SetDecoupledRequestMaxTime("000010");
//      mpiThreeDSAuthentication.SetDecoupledRequestAsyncURL("localhost");
      mpiThreeDSAuthentication.SetRiIndicator("01");
//      mpiThreeDSAuthentication.SetRecurringExpiry("20221230");
//      mpiThreeDSAuthentication.SetRecurringFrequency("031");

		Hashtable priorRequestParams = new Hashtable();
        priorRequestParams.Add("prior_request_auth_data", "1");
        priorRequestParams.Add("prior_request_ref", "2c581b9d-7f77-4772-a92b-e11df34bce61");
        priorRequestParams.Add("prior_request_auth_method", "01");
        priorRequestParams.Add("prior_request_auth_timestamp", "202308151640");
        PaiInfo pai = new PaiInfo();
        pai.SetPriorRequest(priorRequestParams);
        mpiThreeDSAuthentication.setPriorRequestAuthInfo(pai);

        HttpsPostRequest mpgReq = new HttpsPostRequest();
		mpgReq.SetProcCountryCode(processing_country_code);
		mpgReq.SetTestMode(true); //false or comment out this line for production transactions
		mpgReq.SetStoreId(store_id);
		mpgReq.SetApiToken(api_token);
		mpgReq.SetTransaction(mpiThreeDSAuthentication);
		mpgReq.Send();

		/**********************   REQUEST  ************************/

		try
		{
			Receipt receipt = mpgReq.GetReceipt();

			Console.WriteLine("ResponseCode = " + receipt.GetResponseCode());
			Console.WriteLine("ReceiptId = " + receipt.GetReceiptId());
			Console.WriteLine("Message = " + receipt.GetMessage());
			
			Console.WriteLine("MessageType = " + receipt.GetMpiMessageType());
			Console.WriteLine("TransStatus = " + receipt.GetMpiTransStatus());
            Console.WriteLine("TransStatusReason = " + receipt.GetMpiTransStatusReason());
            Console.WriteLine("ChallengeURL = " + receipt.GetMpiChallengeURL());
			Console.WriteLine("ChallengeData = " + receipt.GetMpiChallengeData());
            Console.WriteLine("ThreeDSServerTransId = " + receipt.GetMpiThreeDSServerTransId());
            Console.WriteLine("ThreeDSAcsTransID = " + receipt.GetMpiThreeDSAcsTransID());
            Console.WriteLine("ThreeDSVersion = " + receipt.GetThreeDSVersion());
            Console.WriteLine("DSTransId = " + receipt.GetMpiDSTransId());
            Console.WriteLine("ThreeDSAuthTimeStamp = " + receipt.GetMpiThreeDSAuthTimeStamp());
            Console.WriteLine("AuthenticationType = " + receipt.GetMpiAuthenticationType());
            Console.WriteLine("CardHolder = " + receipt.GetMpiCardholderInfo());

            //In Frictionless flow, you may receive TransStatus as "Y",
            //in which case you can then proceed directly to Cavv Purchase/Preauth with values below
            if (receipt.GetMpiTransStatus().Equals("Y"))
			{
				Console.WriteLine("Cavv = " + receipt.GetMpiCavv());
				Console.WriteLine("ECI = " + receipt.GetMpiEci());
			}
		}
		catch (Exception e)
		{
			Console.WriteLine(e);
		}
	}
}
`}
                </pre>)

        case _JAVA:
            return (
                <pre className="sampleCode">
{`package Canada;

import JavaAPI.*;

public class TestCanadaMpiThreeDSAuthentication
{
	public static void main(String[] args)
	{
		String store_id = "moneris";
		String api_token = "hurgle";
		String prior_request_ref="d7c1ee99-9478-44a6-b1f2-391e29c6b340";
		String prior_request_auth_data="abc";
		String prior_request_auth_method = "01";
		String prior_request_auth_timestamp = "201710282113";
		String processing_country_code = "CA";

		MpiThreeDSAuthentication mpiThreeDSAuthentication = new MpiThreeDSAuthentication();
        mpiThreeDSAuthentication.setOrderId("Test159787ssa3215193");	//must be the same one that was used in MpiCardLookup call
        mpiThreeDSAuthentication.setCardholderName("Moneris Test");
        mpiThreeDSAuthentication.setPan("347668693641199");
//        mpiThreeDSAuthentication.setDataKey("xRl9O4FgrZUYdGkmqHTqiEw97"); //Optional - For Moneris Vault and Hosted Tokenization tokens in place of setPan
        mpiThreeDSAuthentication.setExpdate("2310");
        mpiThreeDSAuthentication.setAmount("1.00");
        mpiThreeDSAuthentication.setThreeDSCompletionInd("Y"); //(Y|N|U) indicates whether 3ds method MpiCardLookup was successfully completed
        mpiThreeDSAuthentication.setRequestType("01"); //(01=payment|02=recur)
        mpiThreeDSAuthentication.setPurchaseDate("20200819035249"); //(YYYYMMDDHHMMSS)
        mpiThreeDSAuthentication.setNotificationURL("https://yournotificationurl.com"); //(Website where response from RRes or CRes after challenge will go)
        mpiThreeDSAuthentication.setChallengeWindowSize("03"); //(01 = 250 x 400, 02 = 390 x 400, 03 = 500 x 600, 04 = 600 x 400, 05 = Full screen)
		mpiThreeDSAuthentication.setEmail("test@email.com");

		mpiThreeDSAuthentication.setBrowserUserAgent("Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/80.0.3987.132 Safari/537.36\\");
        mpiThreeDSAuthentication.setBrowserJavaEnabled("true"); //(true|false)
        mpiThreeDSAuthentication.setBrowserScreenHeight("1000"); //(pixel height of cardholder screen)
        mpiThreeDSAuthentication.setBrowserScreenWidth("1920"); //(pixel width of cardholder screen)
        mpiThreeDSAuthentication.setBrowserLanguage("en-GB"); //(defined by IETF BCP47)
        
        //Optional Methods
        mpiThreeDSAuthentication.setBillAddress1("3300 Bloor St W");
        mpiThreeDSAuthentication.setBillProvince("ON");
        mpiThreeDSAuthentication.setBillCity("Toronto");
        mpiThreeDSAuthentication.setBillPostalCode("M8X 2X2");
        mpiThreeDSAuthentication.setBillCountry("124");
        
        mpiThreeDSAuthentication.setShipAddress1("3300 Bloor St W");
        mpiThreeDSAuthentication.setShipProvince("ON");
        mpiThreeDSAuthentication.setShipCity("Toronto");
        mpiThreeDSAuthentication.setShipPostalCode("M8X 2X2");
        mpiThreeDSAuthentication.setShipCountry("124");
        
        mpiThreeDSAuthentication.setRequestChallenge("Y"); //(Y|N Requesting challenge regardless of outcome)
		//**********************3DS2.2*****************************************
		mpiThreeDSAuthentication.setMessageCategory("01");
		mpiThreeDSAuthentication.setDeviceChannel("03");
//		mpiThreeDSAuthentication.setDecoupledRequestIndicator("Y");
//		mpiThreeDSAuthentication.setDecoupledRequestMaxTime("000010");
//		mpiThreeDSAuthentication.setDecoupledRequestAsyncUrl("localhost:8080/googlepay");

		mpiThreeDSAuthentication.setRiIndicator("01");
		PriorAuthenticationInfo priorAuthenticationInfo= new PriorAuthenticationInfo();
		priorAuthenticationInfo.setPriorParams(prior_request_auth_data,prior_request_ref,
				prior_request_auth_method,prior_request_auth_timestamp);
//		mpiThreeDSAuthentication.setRecurringExpiry("20221230");
//		mpiThreeDSAuthentication.setRecurringFrequency("031");


		//************************OPTIONAL VARIABLES***************************

		HttpsPostRequest mpgReq = new HttpsPostRequest();
		mpgReq.setProcCountryCode(processing_country_code);
		mpgReq.setTestMode(true); //false or comment out this line for production transactions
		mpgReq.setStoreId(store_id);
		mpgReq.setApiToken(api_token);
		mpgReq.setTransaction(mpiThreeDSAuthentication);
		System.out.println(mpiThreeDSAuthentication.toXML());
		mpgReq.send();

		/**********************   REQUEST  ************************/

		try
		{
			Receipt receipt = mpgReq.getReceipt();

			System.out.println("ResponseCode = " + receipt.getResponseCode());
			System.out.println("ReceiptId = " + receipt.getReceiptId());
			System.out.println("Message = " + receipt.getMessage());
			System.out.println("MessageType = " + receipt.getMpiMessageType());
			System.out.println("TransStatus = " + receipt.getMpiTransStatus());
			System.out.println("TransStatusReason = " + receipt.getMpiTransStatusReason());
			System.out.println("ChallengeURL = " + receipt.getMpiChallengeURL());
			System.out.println("ChallengeData = " + receipt.getMpiChallengeData());
			System.out.println("ThreeDSServerTransId = " + receipt.getMpiThreeDSServerTransId());

			System.out.println("ThreeDSVersion = " + receipt.getThreeDSVersion());
			System.out.println("ThreeDSAcsTransID = " + receipt.getMpiThreeDSAcsTransID());
			System.out.println("DSTransID = " + receipt.getMpiDSTransId());
			System.out.println("ThreeDSAuthTimeStamp = " + receipt.getMpiThreeDSAuthTimeStamp());
			System.out.println("AuthenticationType = " + receipt.getMpiAuthenticationType());
			System.out.println("CardHolderInfo = " + receipt.getMpiCardholderInfo());

			//In Frictionless flow, you may receive TransStatus as "Y", 
		    //in which case you can then proceed directly to Cavv Purchase/Preauth with values below
		    if(receipt.getMpiTransStatus().equals("Y"))
		    {
		    	System.out.println("Cavv = " + receipt.getMpiCavv());
		    	System.out.println("ECI = " + receipt.getMpiEci());
		    }
		}
		catch (Exception e)
		{
			e.printStackTrace();
		}
	}
} // end TestResMpiTxn
`}
                </pre>
            )

        case _PHP:
            return (
                <pre className="sampleCode">
{`<?php

require "../../mpgClasses.php";

/******************************* Request Variables ********************************/
$store_id = "moneris";
$api_token = "hurgle";

$mpiThreeDSAuthentication = new MpiThreeDSAuthentication();
$mpiThreeDSAuthentication->setOrderId("ord-110920-10:36:41");	//must be the same one that was used in MpiCardLookup call
$mpiThreeDSAuthentication->setCardholderName("Moneris Test");
$mpiThreeDSAuthentication->setPan("347668693641199");
//$mpiThreeDSAuthentication->setDataKey("8OOXGiwxgvfbZngigVFeld9d2"); //Optional - For Moneris Vault and Hosted Tokenization tokens in place of setPan
$mpiThreeDSAuthentication->setExpdate("2310");
$mpiThreeDSAuthentication->setAmount("1.00");
$mpiThreeDSAuthentication->setThreeDSCompletionInd("Y"); //(Y|N|U) indicates whether 3ds method MpiCardLookup was successfully completed
$mpiThreeDSAuthentication->setRequestType("01"); //(01=payment|02=recur)
$mpiThreeDSAuthentication->setPurchaseDate("20200911035249"); //(YYYYMMDDHHMMSS)
$mpiThreeDSAuthentication->setNotificationURL("https://yournotificationurl.com"); //(Website where response from RRes or CRes after challenge will go)
$mpiThreeDSAuthentication->setChallengeWindowSize("03"); //(01 = 250 x 400, 02 = 390 x 400, 03 = 500 x 600, 04 = 600 x 400, 05 = Full screen)

$mpiThreeDSAuthentication->setBrowserUserAgent("Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/80.0.3987.132 Safari/537.36\\");
$mpiThreeDSAuthentication->setBrowserJavaEnabled("true"); //(true|false)
$mpiThreeDSAuthentication->setBrowserScreenHeight("1000"); //(pixel height of cardholder screen)
$mpiThreeDSAuthentication->setBrowserScreenWidth("1920"); //(pixel width of cardholder screen)
$mpiThreeDSAuthentication->setBrowserLanguage("en-GB"); //(defined by IETF BCP47)

//Optional Methods
$mpiThreeDSAuthentication->setBillAddress1("3300 Bloor St W");
$mpiThreeDSAuthentication->setBillProvince("ON");
$mpiThreeDSAuthentication->setBillCity("Toronto");
$mpiThreeDSAuthentication->setBillPostalCode("M8X 2X2");
$mpiThreeDSAuthentication->setBillCountry("124");

$mpiThreeDSAuthentication->setShipAddress1("3300 Bloor St W");
$mpiThreeDSAuthentication->setShipProvince("ON");
$mpiThreeDSAuthentication->setShipCity("Toronto");
$mpiThreeDSAuthentication->setShipPostalCode("M8X 2X2");
$mpiThreeDSAuthentication->setShipCountry("124");

$mpiThreeDSAuthentication->setEmail("test@email.com");
$mpiThreeDSAuthentication->setRequestChallenge("Y"); //(Y|N Requesting challenge regardless of outcome)

$mpiThreeDSAuthentication->setMessageCategory("01");
$mpiThreeDSAuthentication->setDeviceChannel("03");
//$mpiThreeDSAuthentication->setDecoupledReque2tIndicator("N");
//$mpiThreeDSAuthentication->setDecoupledRequestMaxTime("00010");
//$mpiThreeDSAuthentication->setDecoupledRequestAsyncUrl("localhost");
$mpiThreeDSAuthentication->setRiIndicator("01");
// $mpiThreeDSAuthentication->setRecurringFrequency("031");
// $mpiThreeDSAuthentication->setRecurringExpiry("20251230");

$paiTemplate = array(
    'prior_request_auth_data'=>"d7c1ee99-9478-44a6-b1f2-391e29c6b340",
    'prior_request_ref'=>"d7c1ee99-9478-44a6-b1f2-391e29c6b340",
    'prior_request_auth_method'=>"01",
    'prior_request_auth_timestamp'=>"201710282113"
);
 $mpiThreeDSAuthentication->setPriorAuthenticationInfo( $paiTemplate );


/****************************** Transaction Object *******************************/
$mpgTxn = new mpgTransaction($mpiThreeDSAuthentication);

/******************************* Request Object **********************************/

$mpgRequest = new mpgRequest($mpgTxn);
$mpgRequest->setProcCountryCode("CA"); //"US" for sending transaction to US environment
$mpgRequest->setTestMode(true); //false or comment out this line for production transactions

//print_r($mpgRequest);
/****************************** HTTPS Post Object *******************************/
$mpgHttpPost  =new mpgHttpsPost($store_id,$api_token,$mpgRequest);

/************************************* Response *********************************/

$mpgResponse=$mpgHttpPost->getMpgResponse();

print("\nResponseCode = " . $mpgResponse->getResponseCode());
print("\nReceiptId = " . $mpgResponse->getReceiptId());
print("\nMessage = " . $mpgResponse->getMessage());
print("\nMessageType = " . $mpgResponse->getMpiMessageType());
print("\nTransStatus = " . $mpgResponse->getMpiTransStatus());
print("\nTransStatusReason = " . $mpgResponse->getMpiTransStatusReason());
print("\nChallengeURL = " . $mpgResponse->getMpiChallengeURL());
print("\nChallengeData = " . $mpgResponse->getMpiChallengeData());
print("\nThreeDSServerTransId = " . $mpgResponse->getMpiThreeDSServerTransId());
print("\nDSTransId = " . $mpgResponse->getMpiDSTransId());
print("\nThreeDSVersion = " . $mpgResponse->getThreeDSVersion());
print("\nThreeDSAcsTransID = " . $mpgResponse->getMpiThreeDSAcsTransID());
print("\nThreeDSAuthTimeStamp = " . $mpgResponse->getMpiThreeDSAuthTimeStamp());
print("\nAuthenticationType = " . $mpgResponse->getMpiAuthenticationType());
print("\nCardHolderInfo = ".$mpgResponse->getMpiCardholderInfo());

//In Frictionless flow, you may receive TransStatus as "Y", 
//in which case you can then proceed directly to Cavv Purchase/Preauth with values below'
if($mpgResponse->getMpiTransStatus() == "Y")
{
 print("\nCavv = " . $mpgResponse->getMpiCavv());
 print("\nECI = " . $mpgResponse->getMpiEci());
}
?>
`}
                </pre>
            )
        default:
            return null
        }
    }
}

const mapStateToProps = state => {
  const { storeId, apiToken, order_id, pan, onEditId } = state.threeDSTwo.main.config;
  const { selection } = state.common.progLangList;
  return { storeId, apiToken, order_id, pan, selectedProgLangId: selection, onEditId };
}

export default connect(mapStateToProps, {})(_3RINonRecurringSample)
